import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '@/app/baseQuery';
import type { DiscussionEntry, DiscussionNotificationType } from './types';

const PAGE_SIZE = 20;

export interface GetDiscussionsParams {
  blogSlug: string;
  // TODO: backend doesn't support filters[notification_type] yet — restore once it does.
  notificationType: DiscussionNotificationType;
  page?: number;
  pageSize?: number;
}

/** Attached by baseQueryWithAuth as a non-enumerable `meta` property on the response array. */
export interface DiscussionsMeta {
  totalEntries: number;
}

export const discussionsApi = createApi({
  reducerPath: 'discussionsApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Discussions'],
  endpoints: builder => ({
    getDiscussions: builder.query<DiscussionEntry[], GetDiscussionsParams>({
      query: ({ blogSlug, page = 1, pageSize = PAGE_SIZE }) => ({
        url: `blogs/${blogSlug}/discussions`,
        params: {
          include: 'comments,profiles',
          // 'filters[notification_type]': notificationType,
          'page[size]': pageSize,
          'page[number]': page
          // sort: '-created-at'
        }
      }),
      providesTags: ['Discussions']
    })
  })
});

export const { useGetDiscussionsQuery } = discussionsApi;

export { PAGE_SIZE as DISCUSSIONS_PAGE_SIZE };
